<h2 mat-dialog-title>Confirmaci&oacute;n</h2>
<mat-dialog-content>
  Seguro desea eliminar el registro seleccionado?
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial>No</button>
  <button mat-flat-button mat-dialog-close (click)="close()">Si, eliminar</button>
</mat-dialog-actions>
